export default __webpack_public_path__ + "static/media/white-delete-measure-icon.767b4fdb.svg";